import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {FileComponent} from "./files/file.component";

const routes: Routes = [
  {path: 'files', component: FileComponent},
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CmsRouteModule {
}
